/** FastAPI `HTTPException.detail`: string, gate dict, or Pydantic 422 list. */

function asRecord(value: unknown): Record<string, unknown> | null {
  return value && typeof value === 'object' && !Array.isArray(value)
    ? (value as Record<string, unknown>)
    : null;
}

export function httpErrorDetailMessage(detail: unknown, fallback: string): string {
  if (typeof detail === 'string' && detail.trim()) return detail.trim();
  if (Array.isArray(detail)) {
    const parts = detail
      .map((row) => {
        if (typeof row === 'string' && row.trim()) return row.trim();
        const rec = asRecord(row);
        if (!rec) return '';
        const msg = rec.msg ?? rec.message;
        return typeof msg === 'string' ? msg.trim() : '';
      })
      .filter(Boolean);
    return parts.length ? parts.join('; ') : fallback;
  }
  const rec = asRecord(detail);
  if (!rec) return fallback;
  for (const key of ['message', 'msg'] as const) {
    const raw = rec[key];
    if (typeof raw === 'string' && raw.trim()) return raw.trim();
  }
  return fallback;
}
